import { Location } from 'react-router-dom';

export default class Helpers {
  static isEnvProd = (): boolean => {
    const env = `${process.env.REACT_APP_ENV}`;
    return env === 'production';
  };

  static wait = (ms = 500) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  static getQueryParam = (
    location: Location,
    query: string
  ): string | undefined => {
    const searchParams: URLSearchParams = new URLSearchParams(location.search);
    return searchParams.get(query) ?? undefined;
  };
  private static clearNumber(value = ''): string {
    return value.replace(/\D+/g, '');
  }

  public static formatPhoneNumber(value: string): string {
    if (!value) {
      return value;
    }
    const clearValue = this.clearNumber(value);
    const nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
      4,
      7
    )} ${clearValue.slice(7, 9)} ${clearValue.slice(9, 11)}`;
    return nextValue.trim();
  }

  public static getLanguageFromUrl(url: string) {
    const match = url.match(/^https?:\/\/[^\/]+\/(tr|en)(?=\/)/);
    return match ? match[1] : null;
  }

  public static scrollToElementById(id: string) {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}

const PLATE_RE = /^\s*(\d{2})\s*([A-ZÇĞİÖŞÜ]{1,3})\s*(\d{2,4})\s*$/i;

type ParsedPlate = {
  province: number;
  letters: string;
  number: number;
};

function parsePlate(input: string): ParsedPlate | null {
  const m = input.match(PLATE_RE);
  if (!m) return null;

  const province = Number(m[1]);
  // Türkçe büyük harf dönüştürme (İ/i doğru davransın)
  const letters = m[2].toLocaleUpperCase('tr-TR');
  const number = Number(m[3]);

  return { province, letters, number };
}

export function comparePlates(a: string, b: string): number {
  const pa = parsePlate(a);
  const pb = parsePlate(b);

  // Format dışı olanları en sona at (ve kendi aralarında alfabetik sırala)
  if (!pa && !pb) return a.localeCompare(b, 'tr-TR');
  if (!pa) return 1;
  if (!pb) return -1;

  // 1) İl kodu (sayısal)
  if (pa.province !== pb.province) return pa.province - pb.province;

  // 2) Harf grubu (Türkçe locale ile)
  const lc = pa.letters.localeCompare(pb.letters, 'tr-TR');
  if (lc !== 0) return lc;

  // 3) Son sayı (sayısal)
  if (pa.number !== pb.number) return pa.number - pb.number;

  return 0;
}
